import type { ReactElement, ReactNode } from 'react';
import type { HeroProps } from '../shell';
import { SettingsFrame } from '../settings/Frame';

/**
 * The Admin tabs (SYS1–SYS8, boards' order). The console isn't a tab: it's where Admin opens, and
 * every tab's hero links back to it.
 */
export const ADMIN_TABS = [
  { id: 'people', label: 'People', href: '/settings/system/people' },
  { id: 'directory', label: 'Directory sync', href: '/settings/system/directory' },
  { id: 'roles', label: 'Roles & lists', href: '/settings/system/roles' },
  { id: 'types', label: 'Award types & features', href: '/settings/system/types' },
  { id: 'ai', label: 'AI', href: '/settings/system/ai' },
  { id: 'preview', label: 'Preview & testing', href: '/settings/system/preview' },
  { id: 'audit', label: 'Audit log', href: '/settings/system/audit-log' },
] as const;

export type AdminTabId = (typeof ADMIN_TABS)[number]['id'];

export const CONSOLE_BACK = {
  href: '/settings/system',
  // The visible words are in the link's name (WCAG 2.5.3), so "System overview" either way.
  label: 'System overview',
  name: 'Back to the System overview',
} as const;

/** A tab's page: its hero (with the way back to the console), the Admin tabs, then the body. */
export function AdminFrame({
  hero,
  children,
  console: isConsole = false,
}: {
  hero: HeroProps;
  children: ReactNode;
  /** The console itself: no way back, and no tab is current. */
  console?: boolean;
}): ReactElement {
  return (
    <SettingsFrame
      section="settings"
      hero={{ ...(isConsole ? {} : { back: CONSOLE_BACK }), ...hero }}
    >
      {children}
    </SettingsFrame>
  );
}
